import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import RefundListLayer from "../components/RefundListLayer";

const RefundListPage = () => {
    return (
        <MasterLayout>
            <RefundListLayer />
        </MasterLayout>
    );
};

export default RefundListPage;
